import React from "react";

const Leave = () => {
  return (
    <div className="payroll-container">
      <h2>Comming Soon </h2>
    </div>
  );
};

export default Leave;
